import { createSlice, isAnyOf, PayloadAction } from '@reduxjs/toolkit'
import { getRiskMitigationRowGroupedData } from './row-grouping.async'

const initialState = {
  riskMitigationRowGroupedLoader: false,
  riskMitigationRowGroupedData: [],
}

const RiskMitigationRowGroupingReducer = createSlice({
  name: 'RiskMitigationRowGroupingReducer',
  initialState,
  reducers: {
    emptyRiskMitigationRowGroupedReducer: (state) => {},
  },
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(getRiskMitigationRowGroupedData.pending), (state) => {
      state.riskMitigationRowGroupedLoader = true
    })
    builder.addMatcher(isAnyOf(getRiskMitigationRowGroupedData.fulfilled), (state, action) => {
      state.riskMitigationRowGroupedLoader = false
      state.riskMitigationRowGroupedData = action.payload.data
    })
    builder.addMatcher(isAnyOf(getRiskMitigationRowGroupedData.rejected), (state) => {
      state.riskMitigationRowGroupedLoader = false
    })
  },
})

export const { emptyRiskMitigationRowGroupedReducer } = RiskMitigationRowGroupingReducer.actions
export default RiskMitigationRowGroupingReducer.reducer
